import styled from "styled-components";
import { medals } from "../../../../constants/medals";

export const Container = styled.div<{ unlockOrder?: number }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  ${({ unlockOrder }) => unlockOrder ? `background: ${medals[unlockOrder - 1]?.background_vertical || "#EEE"};` : ""}
  border-radius: 12px;
  padding: 24px 44px;
  position: relative;
  
  @media (max-width: 768px) {
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 20px 16px 30px;
    gap: 8px;
  }
`;

export const Medal = styled.div`
  
`;

export const Content = styled.div`
  width: 100%;

  h4 {
    margin: 0px;
    font-size: 18px;
    line-height: 22px;
    color: black;
    font-weight: 500;
    width: 100%;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 18px;
    }
  }

  h2 {
    margin: 0px;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    color: black;
  }
`;

export const ExploreButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: linear-gradient(90deg,rgba(47, 47, 49, 1) 0%, rgba(0, 0, 0, 1) 100%);
  color: white;
  min-width: 210px;
  height: 50px;
  border-radius: 15px;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  padding: 0px 12px;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 768px) {
    min-width: 140px;
    height: 30px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 13px;
  right: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;

  @media (max-width: 768px) {
    top: 9px;
    right: 10px;
  }
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`